module.exports = __webpack_public_path__ + "img/success.42bdf11c.svg";